import { COLORS } from '@mafc/common';
import { customStyled, Flex, Box } from '@mafc/trolly';
import colors from '../../../../theme/colors';

export const Container = customStyled(Flex)(props => ({
  alignItems: 'center',
  background: props.theme.colors.error,
  padding: `${props.theme.space[3]}px`,
  marginBottom: props.isMobile ? `16px` : '48px',
  fontFamily: props.theme.fonts.montserrat,
}));

export const NowMessage = customStyled(Box)(() => ({
  paddingLeft: '12px',
  color: colors.ERROR_RED,
}));

export const IconWrapper = customStyled(Flex)(props => ({
  alignItems: 'center',
  background: COLORS.WHITE,
  borderRadius: '50%',
  height: '48px',
  justifyContent: 'center',
  marginRight: `${props.theme.space[3]}px`,
  width: '48px',
}));
